document.addEventListener('DOMContentLoaded', function () {
  const toggle = document.querySelector('.header__search-toggle');
  const searchBar = document.querySelector('.header__search-bar-container');
  if (!toggle || !searchBar) return;
  toggle.addEventListener('click', function () {
    searchBar.classList.toggle('is-visible');
    let searchInput = document.querySelector(".search-bar__input");
    if(searchInput){
      setTimeout(function(){
          searchInput.focus();
      },800);
    }
  });
});

// document.addEventListener('variant:change', function(event) {
//   const variant = event?.detail?.variant;
//   if (!variant) return;

//   const skuBlocks = document.querySelectorAll('.product-sku[data-block-id]');
//   skuBlocks.forEach(el => {
//     el.textContent = 'Varenr. ' + variant.sku;
//   });
// });

document.addEventListener('variant:change', function(event) {
  const variant = event?.detail?.variant;
  if (!variant) return;

  const skuBlocks = document.querySelectorAll('.product-sku[data-block-id]');

  skuBlocks.forEach(el => {
    const valueEl = el.querySelector('.sku-value');
    if (valueEl) {
      valueEl.textContent = variant.sku || '';
    }
  });
});

document.addEventListener('variant:change', function(event) {
  const variant = event.detail.variant;
  if (!variant) return;

  const priceWrapper = document.querySelector('[data-product-price]');
  if (!priceWrapper) return;

  const priceEl = priceWrapper.querySelector('[data-price]');
  const compareEl = priceWrapper.querySelector('[data-compare-price]');
  const compareWrapper = priceWrapper.querySelector('[data-compare-wrapper]');
  const badgeEl = priceWrapper.querySelector('[data-discount-badge]');
  const currency = Shopify.currency.active;
  // Force currency display
  const formatCurrency = (amount) => {
    const value = (amount / 100).toFixed(2).replace('.', ',');

    if(currency == 'EUR'){
       return "€"+ value + ' EUR';
    }
    return value + ' DKK';
  };

  // Update main price
  if (priceEl) {
    priceEl.innerHTML = formatCurrency(variant.price);
  }

  // If variant has compare price
  if (variant.compare_at_price && variant.compare_at_price > variant.price) {

    if (compareEl) {
      compareEl.innerHTML = formatCurrency(variant.compare_at_price);
      compareEl.style.display = 'inline';
    }

    if (compareWrapper) {
      compareWrapper.style.display = 'inline';
    }

    const discount = Math.floor(
      ((variant.compare_at_price - variant.price) / variant.compare_at_price) * 100
    );

    if (badgeEl) {
      badgeEl.innerHTML = `-${discount}%`;
      badgeEl.style.display = 'inline-block';
    }

  } else {

    if (compareEl) {
      compareEl.style.display = 'none';
    }

    if (compareWrapper) {
      compareWrapper.style.display = 'none';
    }

    if (badgeEl) {
      badgeEl.style.display = 'none';
    }
  }
});


document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-expandable]').forEach(wrapper => {
    const content = wrapper.querySelector('[data-expandable-content]');
    const button = wrapper.querySelector('[data-expandable-toggle]');
    const moreText = button.querySelector('[data-more-text]');
    const lessText = button.querySelector('[data-less-text]');

    const collapsedHeight = 120; // adjust height

    if (content.scrollHeight <= collapsedHeight) {
      button.style.display = 'none';
      return;
    }

    content.style.maxHeight = collapsedHeight + 'px';
    content.style.overflow = 'hidden';
    content.style.transition = 'max-height 0.4s ease';

    let expanded = false;

    button.addEventListener('click', function () {
      expanded = !expanded;

      if (expanded) {
        content.style.maxHeight = content.scrollHeight + 'px';
        moreText.style.display = 'none';
        lessText.style.display = 'inline';
      } else {
        content.style.maxHeight = collapsedHeight + 'px';
        moreText.style.display = 'inline';
        lessText.style.display = 'none';
      }
    });
  });
});

document.addEventListener("DOMContentLoaded", function() {

  let currentFamily = null;

  function normalize(str) {
    return str ? str.trim().toLowerCase() : '';
  }

  function applyFilter() {
    if (!currentFamily) return;

    const colorItems = COLOR_FAMILIES
      .filter(item => normalize(item.family_name) === currentFamily)
      .map(item => normalize(item.color_name));

    let firstVisibleSwatch = null;
    let selectedStillValid = false;

    document.querySelectorAll('.color-swatch').forEach(swatch => {
      const label = swatch.querySelector('.color-swatch__item');
      const radio = swatch.querySelector('input[type="radio"]');
      if (!label || !radio) return;

      const swatchTitle = normalize(label.getAttribute('title'));

      if (colorItems.includes(swatchTitle)) {
        swatch.style.display = 'block';

        if (!firstVisibleSwatch) {
          firstVisibleSwatch = swatch;
        }

        if (radio.checked) {
          selectedStillValid = true;
        }

      } else {
        swatch.style.display = 'none';
      }
    });

    // Restore active family button
    document.querySelectorAll('.family-item').forEach(btn => {
      btn.classList.toggle(
        'is-active',
        normalize(btn.dataset.family) === currentFamily
      );
    });

    // Only auto-select if current selection is NOT valid
    if (!selectedStillValid && firstVisibleSwatch) {
      const radio = firstVisibleSwatch.querySelector('input[type="radio"]');
      if (radio) {
        radio.click();
      }
    }
  }

  // Click family
  document.addEventListener("click", function(event) {
    const familyButton = event.target.closest('.family-item');
    if (!familyButton) return;

    currentFamily = normalize(familyButton.dataset.family);
    applyFilter();
  });

  // Reapply after variant change
  document.addEventListener("variant:change", function() {
    setTimeout(applyFilter, 10);
  });

});

document.addEventListener('DOMContentLoaded', function () {

  const links = document.querySelectorAll('.contact-tabs__btn[href^="#"]');

  links.forEach(link => {
    link.addEventListener('click', function () {

      // remove all active
      links.forEach(l => l.classList.remove('is-active'));

      // add active to clicked
      this.classList.add('is-active');
    });
  });

});


document.addEventListener('click', function (e) {
  const link = e.target.closest('.contact-tabs__btn[href^="#"]');
  if (!link) return;

  e.preventDefault();

  const links = document.querySelectorAll('.contact-tabs__btn');
  
  if (!links.length) return;

  links.forEach(l => l.classList.remove('is-active'));

  link.classList.add('is-active');

  const id = link.getAttribute('href');
  const el = document.querySelector(id);

  if (!el) return;

  const headerHeight = parseInt(
    getComputedStyle(document.documentElement)
      .getPropertyValue('--header-height')
  ) || 0;

  const offset = headerHeight + 20;

  window.scrollTo({
    top: el.getBoundingClientRect().top + window.pageYOffset - offset,
    behavior: 'smooth'
  });

});

// document.addEventListener('DOMContentLoaded', function () {
//   document.querySelectorAll('.product-info__block-item').forEach(function (block) {
//     if (!block.innerText.trim()) {
//       block.style.display = 'none';
//     }
//   });
// });

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.product-info__block-item').forEach(function (block) {
    // Check if the block does NOT contain the specific classes
    if (!block.classList.contains('product-info__block-item--product-quantity') && 
        !block.classList.contains('product-info__block-item--variant-dropdown')) {
      // If the block is empty (no inner text), hide it
      if (!block.innerText.trim()) {
        block.style.display = 'none';
      }
    }
  });
});


document.addEventListener('click', (event) => {
  if (event.target.closest('.mini-cart__close-button')) {
    const cartToggle = document.querySelector('.header__cart-toggle');
    if (cartToggle) {
      cartToggle.click();
    } else {
      console.warn('Cart toggle not found!');
    }
  }
});

const cartToggle = document.querySelector('.header__cart-toggle');

function adjustMiniCartHeight() {
  const lineItemList = document.querySelector('.mini-cart__content');
  const recap = document.querySelector('.mini-cart__recap');
  if(lineItemList && recap){
    const recapHeight = recap.offsetHeight;
    lineItemList.style.height = `calc(100% - ${recapHeight}px)`; 
    // console.log('Height applied:', lineItemList.style.height);
  }
}

const observer = new MutationObserver((mutationsList, observer) => {
  const miniCart = document.querySelector('.mini-cart__content');
  if(miniCart){
    adjustMiniCartHeight();
    // observer.disconnect();
  }
});



const el = document.querySelector('#ProductJson');

if (el) {
  const productData = JSON.parse(el.dataset.product);
  // console.log(productData);
}

observer.observe(document.body, { childList: true, subtree: true });

cartToggle.addEventListener('click', () => {
  setTimeout(adjustMiniCartHeight, 150);
});

window.addEventListener('resize', () => {
  adjustMiniCartHeight();
});


// document.addEventListener('DOMContentLoaded', function () {
//   const toggle = document.querySelector('.dropdown-toggle');
//   const menu = document.querySelector('.dropdown-menu');
//   const items = document.querySelectorAll('.dropdown-item');
//   const colorItems = document.querySelectorAll('.base-color-item'); // Base color items for display
//   const colorSwatches = document.querySelectorAll('.color-swatch__item'); // Color swatch inputs

//   if (!toggle || !menu) return;

//   // Toggle dropdown visibility (using display property)
//   toggle.addEventListener('click', () => {
//     const isVisible = menu.style.display === 'block';
//     menu.style.display = isVisible ? 'none' : 'block';  // Toggle between 'none' and 'block'
//   });

// function updateItemColors() {
//   items.forEach(item => {
//     const variantId = item.dataset.variantId;
//     const variant = window.productVariants?.find(v => v.id == variantId);
//     if (variant) {
//       const variantTitle = variant.title;
      
//       const colorSwatchItem = Array.from(colorSwatches).find(swatch => swatch.getAttribute('title') === variantTitle);
      
//       if (colorSwatchItem) {
//         const color = colorSwatchItem.style.backgroundColor || 'transparent'; 
//         const dropdownItemColor = item.querySelector('.dropdown-item-color');
//         if (dropdownItemColor) {
//           dropdownItemColor.style.backgroundColor = color; 
//         }
//       }
//     }
//   });
// }

//   // Handle variant selection from the dropdown
//   items.forEach(item => {
//     item.addEventListener('click', () => {

//       const variantId = item.dataset.variantId;
//       const variant = window.productVariants?.find(v => v.id == variantId);
//       if (!variant) return;

//       // Update swatch/option inputs based on selected variant options
//       variant.options.forEach((value, index) => {
//         const optionIndex = index + 1;
//         const inputs = document.querySelectorAll(`[name="option${optionIndex}"]`);
//         inputs.forEach(input => {
//           if (input.value === value) {
//             input.checked = true;
//             input.dispatchEvent(new Event('input', { bubbles: true }));
//             input.dispatchEvent(new Event('change', { bubbles: true }));
//           }
//         });
//       });

//       // Update hidden variant ID input
//       const idInput = document.querySelector('input[name="id"]');
//       if (idInput) {
//         idInput.value = variantId;
//       }

//       // Trigger variant-picker event
//       const picker = document.querySelector('variant-picker');
//       if (picker) {
//         picker.dispatchEvent(new CustomEvent('variant:change', {
//           bubbles: true,
//           detail: { variant }
//         }));
//       }

//       // Update the UI dropdown with selected variant text
//       toggle.innerHTML = item.innerHTML;
      
//       // Save selected variant to localStorage
//       localStorage.setItem('selectedVariantId', variantId);
//       localStorage.setItem('selectedVariantTitle', variant.title);
      
//       menu.style.display = 'none'; // Close the dropdown immediately after selection

//       // Update color based on selected variant
//       const selectedColorTitle = variant.title;
//       const colorGid = VARIANT_MAP[variant.title]?.gid; // Associated color GID
//       if (colorGid) {
//         const selectedColorItem = document.querySelector(`.base-color-item[data-gid="${colorGid}"]`);
//         colorItems.forEach(c => c.classList.remove('active'));
//         if (selectedColorItem) {
//           selectedColorItem.classList.add('active');
//         }
//       }

//       // Check the correct color swatch and update the input state
//       colorSwatches.forEach(swatch => {
//         const colorTitle = swatch.getAttribute('title');
//         if (colorTitle === selectedColorTitle) {
//           const radioInput = swatch.closest('.color-swatch').querySelector('input[type="radio"]');
//           if (radioInput) {
//             radioInput.checked = true;
//             radioInput.dispatchEvent(new Event('change', { bubbles: true }));
//           }
//         }
//       });
//     });
//   });

//   // Monitor changes to dropdown-toggle and save to localStorage
//   const dropdownToggle = document.querySelector('.dropdown-toggle');
//   if (dropdownToggle) {
//     const observer = new MutationObserver(() => {
//       const toggleContent = dropdownToggle.innerHTML;
//       localStorage.setItem('dropdownToggleState', toggleContent);
//       console.log(' Dropdown toggle changed, saved to localStorage');
//     });
    
//     observer.observe(dropdownToggle, { 
//       childList: true, 
//       subtree: true, 
//       characterData: true,
//       attributes: true 
//     });
//   }

//   // Restore dropdown-toggle state from localStorage on page load
//   const savedToggleState = localStorage.getItem('dropdownToggleState');
//   if (savedToggleState && dropdownToggle) {
//     dropdownToggle.innerHTML = savedToggleState;
//     console.log(' Restored dropdown toggle state from localStorage');
//   }

//   // Close dropdown when clicking outside
//   document.addEventListener('click', (e) => {
//     if (!e.target.closest('.custom-dropdown')) {
//       menu.style.display = 'none'; // Close the dropdown when clicking outside
//     }
//   });

//   // Update color for all dropdown items on page load
//   updateItemColors();
// });



document.addEventListener('DOMContentLoaded', function () {
  const toggle = document.querySelector('.dropdown-toggle');
  const menu = document.querySelector('.dropdown-menu');
  const items = document.querySelectorAll('.dropdown-item');
  const colorItems = document.querySelectorAll('.base-color-item');
  const colorSwatches = document.querySelectorAll('.color-swatch__item');

  if (!toggle || !menu) return;

  /* ================= CORE STATE ================= */

  function getVariantFromUrl() {
    const params = new URLSearchParams(window.location.search);
    return params.get('variant');
  }

  function setVariantToUrl(variantId) {
    const url = new URL(window.location.href);
    url.searchParams.set('variant', variantId);
    window.history.replaceState({}, '', url);
  }

  function getVariantData(variantId) {
    return window.productVariants?.find(v => v.id == variantId);
  }

function extractId(str) {
  if (!str) return '';

  const match = str.match(/\(([^)]+)\)/);
  return match ? match[1].trim() : '';
}

function getColorFromVariantId(variantId) {
  const swatch = document.querySelector(
    `.color-swatch__item[data-variant-id="${variantId}"]`
  );

  if (!swatch) return 'transparent';

  return swatch.style.backgroundColor || 'transparent';
}

function getColorFromTitle(title) {
  const targetId = extractId(title);

  if (!targetId) return 'transparent';

  const swatch = Array.from(colorSwatches).find(s => {
    const swatchTitle = s.getAttribute('title');
    const swatchId = extractId(swatchTitle);
    return swatchId === targetId;
  });

  return swatch ? swatch.style.backgroundColor : 'transparent';
}

  /* ================= MAIN UPDATE ================= */
  
  function syncVariantUI(variant) {
    if (!variant) return;

    const variantIdInput = document.querySelector('input[name="id"]');
    if (variantIdInput) {
      variantIdInput.value = variant.id;
    }

    // Sync options
    variant.options.forEach((value, index) => {
      const inputs = document.querySelectorAll(`[name="option${index + 1}"]`);
      inputs.forEach(input => {
        if (input.value === value) {
          input.checked = true;
          input.dispatchEvent(new Event('input', { bubbles: true }));
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    });

    /* ===== BASE COLOR ===== */
    const gid = VARIANT_MAP?.[variant.id]?.gid;

    if (gid) {
      const selectedColorItem = document.querySelector(`.base-color-item[data-gid="${gid}"]`);
      document.querySelectorAll('.base-color-item').forEach(c => c.classList.remove('active'));
      if (selectedColorItem) {
        selectedColorItem.classList.add('active');
      }
    }

    /* ===== SWATCH ===== */
    document.querySelectorAll('.color-swatch__item').forEach(swatch => {
      const colorTitle = swatch.getAttribute('title');

      if (swatch.dataset.variantId == variant.id) {
        const radio = swatch.closest('.color-swatch')?.querySelector('input[type="radio"]');

        if (radio && !radio.checked) {
          radio.checked = true;
          radio.dispatchEvent(new Event('change', { bubbles: true }));
        }

        swatch.classList.add('active');
      } else {
        swatch.classList.remove('active');
      }
    });

    /* ===== EVENT ===== */
    const picker = document.querySelector('variant-picker');
    if (picker) {
      picker.dispatchEvent(new CustomEvent('variant:change', {
        bubbles: true,
        detail: { variant }
      }));
    }
  }
  function applyVariant(variantId, source = 'manual') {
    const variant = getVariantData(variantId);
    if (!variant) return;

    // URL
    setVariantToUrl(variantId);

    // SAVE
    localStorage.setItem('selectedVariantId', variantId);

    // Form input
    const idInput = document.querySelector('input[name="id"]');
    if (idInput) idInput.value = variantId;

    // Sync options
    variant.options.forEach((value, index) => {
      const inputs = document.querySelectorAll(`[name="option${index + 1}"]`);
      inputs.forEach(input => {
        if (input.value === value) {
          input.checked = true;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    });

    // Shopify event
    const picker = document.querySelector('variant-picker');
    if (picker) {
      picker.dispatchEvent(new CustomEvent('variant:change', {
        bubbles: true,
        detail: { variant }
      }));
    }

    /* ===== UI UPDATE ===== */

    const item = Array.from(getAllItems()).find(
      i => i.dataset.variantId == variantId
    );

    if (!item) return;

    const skuEl = toggle.querySelector('.selected-sku');
    const colorEl = toggle.querySelector('.dropdown-item-color');

    // SKU
    if (skuEl) {
      skuEl.textContent = item.dataset.sku || '';
    }

    const color = getColorFromItem(item);

    if (colorEl) {
      colorEl.style.backgroundColor = color;
    }

    // Active dropdown
    getAllItems().forEach(i => i.classList.remove('active'));
    item.classList.add('active');

    // Active swatch
    getAllSwatches().forEach(s => {
      s.classList.toggle('active', s.dataset.variantId == variantId);
    });
    
  }

  /* ================= EVENTS ================= */

  // Toggle dropdown
 toggle.addEventListener('click', (e) => {
  e.stopPropagation();

  menu.style.display =
    menu.style.display === 'block'
      ? 'none'
      : 'block';
});
// Click outside -> hide dropdown
document.addEventListener('click', (e) => {
  const isClickInside =
    toggle.contains(e.target) ||
    menu.contains(e.target);

  if (!isClickInside) {
    menu.style.display = 'none';
  }
});
  // Dropdown click
 document.addEventListener('click', (e) => {
  const item = e.target.closest('.dropdown-item');
  if (!item) return;

  const variantId = item.dataset.variantId;
  if (!variantId) return;

  const variant = window.productVariants?.find(v => v.id == variantId);
  if (!variant) return;

  syncVariantUI(variant);

  // UI dropdown
  const toggle = document.querySelector('.dropdown-toggle');
  if (toggle) {
    toggle.innerHTML = item.innerHTML;
  }

  // Active dropdown
  document.querySelectorAll('.dropdown-item').forEach(i => i.classList.remove('active'));
  item.classList.add('active');

  const url = new URL(window.location.href);
  url.searchParams.set('variant', variantId);
  window.history.replaceState({}, '', url);
  localStorage.setItem('selectedVariantId', variantId);

  const menu = document.querySelector('.dropdown-menu');
  if (menu) menu.style.display = 'none';
});

  // Swatch click
  document.addEventListener('click', (e) => {
    const swatch = e.target.closest('.color-swatch__item');
    if (!swatch) return;

    const variantId = swatch.dataset.variantId;
    if (variantId) {
      applyVariant(variantId);
    }
  });

  /* ================= UI HELPERS ================= */
function getAllItems() {
  return document.querySelectorAll('.dropdown-item');
}

function getAllSwatches() {
  return document.querySelectorAll('.color-swatch__item');
}
function getColorFromItem(item) {
  const el = item?.querySelector('.dropdown-item-color');
  if (!el) return 'transparent';
  return getComputedStyle(el).backgroundColor;
}
  function setActiveItem(item) {
    items.forEach(i => i.classList.remove('active'));
    colorItems.forEach(c => c.classList.remove('active'));
    colorSwatches.forEach(s => s.classList.remove('active'));

    item.classList.add('active');
  }

  function updateDropdownColor(title) {
    const color = getColorFromTitle(title);
    const el = toggle.querySelector('.dropdown-item-color');
    if (el) el.style.backgroundColor = color;
  }

  function updateItemColors() {
    items.forEach(item => {
      const variant = getVariantData(item.dataset.variantId);
      if (!variant) return;
const color = getColorFromVariantId(variant.id);
      // const color = getColorFromTitle(variant.title);
      const el = item.querySelector('.dropdown-item-color');
      if (el) el.style.backgroundColor = color;
    });
  }

  /* ================= RESTORE ================= */

  function init() {
    updateItemColors();

    let variantId = getVariantFromUrl();

    // fallback localStorage
    if (!variantId) {
      variantId = localStorage.getItem('selectedVariantId');
    }

    // fallback Shopify default
    if (!variantId && window.productVariants?.length) {
      variantId = window.productVariants[0].id;
    }

    if (variantId) {
      applyVariant(variantId, 'init');
    }

    const hasSku = toggle.querySelector('.selected-sku')?.textContent?.trim();

    if (!hasSku) {
      const firstItem = items[0];

      if (firstItem) {
        // set UI dropdown
        toggle.innerHTML = firstItem.innerHTML;

        // set SKU
        const skuEl = toggle.querySelector('.selected-sku');
        if (skuEl) {
          skuEl.textContent = firstItem.dataset.sku || '';
        }

        // set COLOR
        const colorEl = toggle.querySelector('.dropdown-item-color');
        const itemColor = firstItem.querySelector('.dropdown-item-color');

        if (colorEl && itemColor) {
          const c = getComputedStyle(itemColor).backgroundColor;
          colorEl.style.backgroundColor = c;
        }
      }
    }
  }

  init();
});

document.addEventListener('variant:change', function (e) {
  const variant = e.detail?.variant;
  if (!variant) return;

  const item = document.querySelector(
    `.dropdown-item[data-variant-id="${variant.id}"]`
  );

  const toggle = document.querySelector('.dropdown-toggle');
  if (!item || !toggle) return;

  const skuEl = toggle.querySelector('.selected-sku');
  const colorEl = toggle.querySelector('.dropdown-item-color');

  if (skuEl) {
    skuEl.textContent = item.dataset.sku || '';
  }

  const colorElItem = item.querySelector('.dropdown-item-color');
  let color = 'transparent';

  if (colorElItem) {
    const c = getComputedStyle(colorElItem).backgroundColor;
    if (c && c !== 'rgba(0, 0, 0, 0)') {
      color = c;
    }
  }

  if (!color || color === 'transparent') {
    color = item.dataset.color || 'transparent';
  }

  if (colorEl) {
    colorEl.style.backgroundColor = color;
  }
});

// /*
// ==================================================
// RELATED PRODUCTS BY VARIANT
// ==================================================
// */

// (function () {

//   let defaultRecommendationsHTML = null;

//   function updateRelatedProducts(variantId) {

//     if (!variantId) return;

//     const relatedProductsList = document.querySelector(
//       '#related-products-list'
//     );

//     if (!relatedProductsList) return;

//     /*
//     ----------------------------------------
//     SAVE DEFAULT HTML
//     ----------------------------------------
//     */

//     if (!defaultRecommendationsHTML) {

//       defaultRecommendationsHTML =
//         relatedProductsList.innerHTML;

//     }

//     /*
//     ----------------------------------------
//     GET MANUAL PRODUCTS
//     ----------------------------------------
//     */

//     const manualProducts = document.querySelector(
//       `.variant-related-products[data-variant-id="${variantId}"]`
//     );

//     /*
//     ----------------------------------------
//     DESTROY FLICKITY
//     ----------------------------------------
//     */

//     if (window.Flickity) {

//       const flkty = Flickity.data(
//         relatedProductsList
//       );

//       if (flkty) {
//         flkty.destroy();
//       }

//     }

//     /*
//     ----------------------------------------
//     UPDATE HTML
//     ----------------------------------------
//     */

//     if (
//       manualProducts &&
//       manualProducts.dataset.hasProducts === 'true'
//     ) {

//       console.log('SHOW MANUAL');

//       relatedProductsList.innerHTML =
//         manualProducts.innerHTML;

//     } else {

//       console.log('SHOW DEFAULT');

//       relatedProductsList.innerHTML =
//         defaultRecommendationsHTML;

//     }

//     /*
//     ----------------------------------------
//     REINIT FLICKITY
//     ----------------------------------------
//     */

//     if (window.Flickity) {

//       new Flickity(relatedProductsList, {
//         cellAlign: 'left',
//         contain: true,
//         groupCells: true,
//         pageDots: false,
//         prevNextButtons: true
//       });

//     }

//   }

//   /*
//   ==================================================
//   INITIAL LOAD
//   ==================================================
//   */

//   document.addEventListener(
//     'DOMContentLoaded',
//     function () {

//       const currentVariantInput =
//         document.querySelector(
//           'input[name="id"]'
//         );

//       if (!currentVariantInput) return;

//       updateRelatedProducts(
//         currentVariantInput.value
//       );

//     }
//   );

//   /*
//   ==================================================
//   VARIANT CHANGE
//   ==================================================
//   */

//   document.addEventListener(
//     'variant:change',
//     function (e) {

//       const variant = e.detail?.variant;

//       if (!variant) return;

//       updateRelatedProducts(
//         variant.id
//       );

//     }
//   );

// })();
// window.addEventListener('load', function () {

//   setTimeout(function () {

//     const currentVariantInput = document.querySelector(
//       'input[name="id"]'
//     );

//     if (!currentVariantInput) {

//       console.log('NO VARIANT INPUT');

//       return;

//     }

//     console.log(
//       'INITIAL VARIANT:',
//       currentVariantInput.value
//     );

//     document.dispatchEvent(
//       new CustomEvent('variant:change', {
//         detail: {
//           variant: {
//             id: currentVariantInput.value
//           }
//         }
//       })
//     );

//   }, 500);

// });

// (function () {

//   let defaultRecommendationsHTML = null;

//   /*
//   ==================================================
//   UPDATE RELATED PRODUCTS
//   ==================================================
//   */

//   function updateRelatedProducts(variantId) {

//     if (!variantId) return;

//     // console.log('VARIANT:', variantId);

//     const relatedProductsList = document.querySelector('#related-products-list');

//     if (relatedProductsList) {
//       relatedProductsList.classList.add('is-loading');
//     }

//     if (!relatedProductsList) return;

//     /*
//     ----------------------------------------
//     SAVE DEFAULT HTML
//     ----------------------------------------
//     */

//     if (!defaultRecommendationsHTML) {

//       defaultRecommendationsHTML =
//         relatedProductsList.innerHTML;

//     }

//     /*
//     ----------------------------------------
//     GET MANUAL PRODUCTS
//     ----------------------------------------
//     */

//     const manualProducts = document.querySelector(
//       `.variant-related-products[data-variant-id="${variantId}"]`
//     );

//     /*
//     ----------------------------------------
//     DESTROY FLICKITY
//     ----------------------------------------
//     */

//     if (window.Flickity) {

//       if (relatedProductsList._flkty) {
//   relatedProductsList._flkty.destroy();
//   relatedProductsList._flkty = null;
// }

//     }

//     /*
//     ----------------------------------------
//     UPDATE HTML
//     ----------------------------------------
//     */

//     if (
//       manualProducts &&
//       manualProducts.dataset.hasProducts === 'true'
//     ) {

//       // console.log('SHOW MANUAL');

//       relatedProductsList.innerHTML =
//         manualProducts.innerHTML;

//     } else {

//       // console.log('SHOW DEFAULT');

//       relatedProductsList.innerHTML =
//         defaultRecommendationsHTML;

//     }

//     /*
//     ----------------------------------------
//     REINIT FLICKITY
//     ----------------------------------------
//     */

//     requestAnimationFrame(() => {

//   // FORCE reflow before init Flickity
//   relatedProductsList.offsetHeight;

//   // reset inline styles Flickity left behind
//   relatedProductsList.style.transform = '';
//   relatedProductsList.style.opacity = '1';

//   const flkty = new Flickity(relatedProductsList, {
//     cellAlign: 'left',
//     contain: true,
//     groupCells: true,
//     pageDots: false,
//     prevNextButtons: true,
//     imagesLoaded: true, 
//     lazyLoad: 2
//   });

//   // store instance (optional but recommended)
//   relatedProductsList._flkty = flkty;

// });

// requestAnimationFrame(function () {

//   if (!relatedProductsList) return;

//   relatedProductsList.classList.remove('is-loading');

//   relatedProductsList.style.transition = 'opacity 0.2s ease';
//   relatedProductsList.style.opacity = '1';

// });
//   }

//   /*
//   ==================================================
//   INITIAL LOAD
//   ==================================================
//   */

//   window.addEventListener('load', function () {

//     const relatedProductsList = document.querySelector(
//       '#related-products-list'
//     );

//     if (relatedProductsList) {

//       relatedProductsList.style.opacity = '0';

//     }
    
//     setTimeout(function () {

//       const currentVariantInput = document.querySelector(
//         'input[name="id"]'
//       );

//       if (!currentVariantInput) {

//         // console.log('NO VARIANT INPUT');

//         return;

//       }

//       // console.log(
//       //   'INITIAL VARIANT:',
//       //   currentVariantInput.value
//       // );

//       updateRelatedProducts(
//         currentVariantInput.value
//       );

//       requestAnimationFrame(function () {

//         if (!relatedProductsList) return;

//         relatedProductsList.style.transition =
//           'opacity 0.2s ease';

//         relatedProductsList.style.opacity =
//           '1';

//       });

//     }, 200);

//   });

//   /*
//   ==================================================
//   VARIANT CHANGE
//   ==================================================
//   */

//   document.addEventListener(
//     'variant:change',
//     function (e) {

//       const variant = e.detail?.variant;

//       if (!variant) return;

//       updateRelatedProducts(
//         variant.id
//       );

//     }
//   );
// })();
// document.addEventListener('DOMContentLoaded', function () {
//   const toggle = document.querySelector('.dropdown-toggle');
//   const menu = document.querySelector('.dropdown-menu');
//   const items = document.querySelectorAll('.dropdown-item');
//   const colorItems = document.querySelectorAll('.base-color-item'); // Base color items for display
//   const colorSwatches = document.querySelectorAll('.color-swatch__item'); // Color swatch inputs

//   if (!toggle || !menu) return;

//   // Toggle dropdown visibility (using display property)
//   toggle.addEventListener('click', () => {
//     const isVisible = menu.style.display === 'block';
//     menu.style.display = isVisible ? 'none' : 'block';  // Toggle between 'none' and 'block'
//   });

//   // Function to update color for each dropdown item based on the variant's color
//   function updateItemColors() {
//     items.forEach(item => {
//       const variantId = item.dataset.variantId;
//       const variant = window.productVariants?.find(v => v.id == variantId);
//       if (variant) {
//         const colorGid = VARIANT_MAP[variant.title]?.gid; // Associated color GID
//         if (colorGid) {
//           // Find the color item element and apply the background color (or use another style)
//           const colorItem = document.querySelector(`.base-color-item[data-gid="${colorGid}"]`);
//           if (colorItem) {
//             const color = colorItem.style.backgroundColor || 'transparent'; // Use the color from the item or default
//             const dropdownItemColor = item.querySelector('.dropdown-item-color');
//             if (dropdownItemColor) {
//               dropdownItemColor.style.backgroundColor = color; // Set background color to the dropdown item
//             }
//           }
//         }
//       }
//     });
//   }

//   // Handle variant selection from the dropdown
//   items.forEach(item => {
//     item.addEventListener('click', () => {
//       const variantId = item.dataset.variantId;
//       const variant = window.productVariants?.find(v => v.id == variantId);
//       if (!variant) return;

//       // Update swatch/option inputs based on selected variant options
//       variant.options.forEach((value, index) => {
//         const optionIndex = index + 1;
//         const inputs = document.querySelectorAll(`[name="option${optionIndex}"]`);
//         inputs.forEach(input => {
//           if (input.value === value) {
//             input.checked = true;
//             input.dispatchEvent(new Event('input', { bubbles: true }));
//             input.dispatchEvent(new Event('change', { bubbles: true }));
//           }
//         });
//       });

//       // Update hidden variant ID input
//       const idInput = document.querySelector('input[name="id"]');
//       if (idInput) {
//         idInput.value = variantId;
//       }

//       // Trigger variant-picker event
//       const picker = document.querySelector('variant-picker');
//       if (picker) {
//         picker.dispatchEvent(new CustomEvent('variant:change', {
//           bubbles: true,
//           detail: { variant }
//         }));
//       }

//       // Update the UI dropdown with selected variant text
//       toggle.innerHTML = item.innerHTML;
//       menu.style.display = 'none'; // Close the dropdown immediately after selection

//       // Update color based on selected variant
//       const selectedColorTitle = variant.title;
//       const colorGid = VARIANT_MAP[variant.title]?.gid; // Associated color GID
//       if (colorGid) {
//         const selectedColorItem = document.querySelector(`.base-color-item[data-gid="${colorGid}"]`);
//         colorItems.forEach(c => c.classList.remove('active'));
//         if (selectedColorItem) {
//           selectedColorItem.classList.add('active');
//         }
//       }

//       // Check the correct color swatch and update the input state
//       colorSwatches.forEach(swatch => {
//         const colorTitle = swatch.getAttribute('title');
//         if (colorTitle === selectedColorTitle) {
//           const radioInput = swatch.closest('.color-swatch').querySelector('input[type="radio"]');
//           if (radioInput) {
//             radioInput.checked = true;
//             radioInput.dispatchEvent(new Event('change', { bubbles: true }));
//           }
//         }
//       });
//     });
//   })

//   // Close dropdown when clicking outside
//   document.addEventListener('click', (e) => {
//     if (!e.target.closest('.custom-dropdown')) {
//       menu.style.display = 'none'; // Close the dropdown when clicking outside
//     }
//   });

//   // Update color for all dropdown items on page load
//   updateItemColors();
// });

// document.addEventListener('variant:change', function () {
//   const variantInput = document.querySelector('input[name="id"]');
//   const currentId = variantInput?.value;

//   const items = document.querySelectorAll('.dropdown-item');
//   const toggle = document.querySelector('.dropdown-toggle');

//   items.forEach(item => {
//     if (item.dataset.variantId === currentId) {
//       toggle.innerHTML = item.innerHTML;
//     }
//   });
// });


document.addEventListener('DOMContentLoaded', function () {
  const productGallery = document.querySelector('.product-gallery__thumbnail-list');
  const variantIdInput = document.querySelector('input[name="id"]');
  const colorItems = document.querySelectorAll('.base-color-item');
  const colorSwatches = document.querySelectorAll('.color-swatch__item');

  if (!variantIdInput || !productGallery) return;

  productGallery.addEventListener('click', (e) => {
    const thumbnail = e.target.closest('.product-gallery__thumbnail');
    if (!thumbnail) return;

    const variantId = thumbnail.dataset.variantId;
    if (!variantId) return;

    const variant = window.productVariants?.find(v => v.id == variantId);
    if (!variant) return;

    variantIdInput.value = variant.id;

    variant.options.forEach((value, index) => {
      const optionIndex = index + 1;
      const inputs = document.querySelectorAll(`[name="option${optionIndex}"]`);
      inputs.forEach(input => {
        if (input.value === value) {
          input.checked = true;
          input.dispatchEvent(new Event('input', { bubbles: true }));
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    });

    // const selectedColorTitle = variant.title;
    // const colorGid = VARIANT_MAP[variant.title]?.gid;
    // if (colorGid) {
    //   const selectedColorItem = document.querySelector(`.base-color-item[data-gid="${colorGid}"]`);
    //   colorItems.forEach(c => c.classList.remove('active'));
    //   if (selectedColorItem) {
    //     selectedColorItem.classList.add('active');
    //   }
    // }

    // colorSwatches.forEach(swatch => {
    //   const colorTitle = swatch.getAttribute('title');
    //   if (colorTitle === selectedColorTitle) {
    //     const radioInput = swatch.closest('.color-swatch').querySelector('input[type="radio"]');
    //     if (radioInput) {
    //       radioInput.checked = true;
    //       radioInput.dispatchEvent(new Event('change', { bubbles: true }));
    //     }
    //   }
    // });
// ===== BASE COLOR =====
const swatch = document.querySelector(
  `.color-swatch__item[data-variant-id="${variant.id}"]`
);

const gid = swatch?.dataset.gid;

if (gid) {
  const selectedColorItem = document.querySelector(`.base-color-item[data-gid="${gid}"]`);
  colorItems.forEach(c => c.classList.remove('active'));
  if (selectedColorItem) {
    selectedColorItem.classList.add('active');
  }
}

// ===== SWATCH =====
colorSwatches.forEach(swatch => {
  const isMatch = swatch.dataset.variantId == variant.id;

  const radioInput = swatch.closest('.color-swatch')?.querySelector('input[type="radio"]');

  if (isMatch) {
    if (radioInput && !radioInput.checked) {
      radioInput.checked = true;
      radioInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
    swatch.classList.add('active');
  } else {
    swatch.classList.remove('active');
  }
});
    const picker = document.querySelector('variant-picker');
    if (picker) {
      picker.dispatchEvent(new CustomEvent('variant:change', {
        bubbles: true,
        detail: { variant }
      }));
    }

    // ===== BLOCK SWATCH SYNC =====
    const activeLabel = document.querySelector(
      `.block-swatch__item[data-variant-id="${variant.id}"]`
    );

    if (activeLabel) {
      const wrapper = activeLabel.closest('.block-swatch');
      if (wrapper) {
        document.querySelectorAll('.block-swatch').forEach(w => w.classList.remove('active'));
        wrapper.classList.add('active');
      }

      const radio = document.getElementById(activeLabel.getAttribute('for'));

      if (radio && !radio.checked) {
        radio.checked = true;
        radio.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

  });

  document.addEventListener('variant:change', function () {
    const currentId = variantIdInput.value;
    const selectedItem = Array.from(document.querySelectorAll('.product-gallery__thumbnail')).find(item => item.dataset.variantId === currentId);
    if (selectedItem) {
      selectedItem.classList.add('is-selected');
    }
  });
});

// document.addEventListener('DOMContentLoaded', () => {

//   const swatches = document.querySelectorAll('.color-swatch__item');

//   swatches.forEach(swatch => {
//     const variantId = swatch.dataset.variantId;

//     const gid = VARIANT_GID_MAP[variantId];

//     if (gid) {
//       swatch.dataset.gid = gid;
//     } else {
//       console.warn('Missing GID for variant:', variantId);
//     }
//   });

// });


function renderMix() {

  const display = document.querySelector(
    '.block-swatch__global-display'
  );

  if (!display) return;

  /*
  ----------------------------------------
  GET ACTIVE SWATCH
  ----------------------------------------
  */

  const active = document.querySelector(
    '.block-swatch__radio:checked'
  );

  if (!active) {

    display.textContent = '';

    return;

  }

  /*
  ----------------------------------------
  GET SWATCH ITEM
  ----------------------------------------
  */

  const swatch = active.closest('.block-swatch');

  if (!swatch) {

    display.textContent = '';

    return;

  }

  const item = swatch.querySelector(
    '.block-swatch__item'
  );

  if (!item) {

    display.textContent = '';

    return;

  }

  /*
  ----------------------------------------
  GET MIX KEY
  ----------------------------------------
  */

  const key = String(
  item.dataset.mix || ''
)
.trim()
.toLowerCase();

if (!key) {

  display.textContent = '';

  return;

}

/*
----------------------------------------
GET CURRENT SORTIMENT
----------------------------------------
*/

const sortiment = String(
  window.PRODUCT_SORTIMENT || ''
)
.trim()
.toLowerCase();

// console.log(
//   'SORTIMENT:',
//   sortiment
// );

/*
----------------------------------------
BUILD LOOKUP KEY
----------------------------------------
*/

const lookupKey =
  `${sortiment}__${key}`;

// console.log(
//   'LOOKUP KEY:',
//   lookupKey
// );

/*
----------------------------------------
GET MIX VALUE
----------------------------------------
*/

const raw =
  window.MIX_COLOR_MAP?.[lookupKey];

// console.log(
//   'MIX VALUE:',
//   raw
// );

display.textContent =
  raw || key || '';
}

/*
==================================================
CHANGE
==================================================
*/

document.addEventListener(
  'change',
  function (e) {

    if (
      !e.target.matches('.block-swatch__radio')
    ) return;

    requestAnimationFrame(function () {

      renderMix();

    });

  }
);

/*
==================================================
INITIAL
==================================================
*/

document.addEventListener(
  'DOMContentLoaded',
  function () {

    requestAnimationFrame(function () {

      renderMix();

    });

  }
);

/*
==================================================
VARIANT CHANGE
==================================================
*/

document.addEventListener(
  'variant:change',
  function () {

    requestAnimationFrame(function () {

      renderMix();

    });

  }
);


// document.addEventListener("DOMContentLoaded", function() {

//   const familyButtons = document.querySelectorAll('.family-item');
//   const colorItems = document.querySelectorAll('.color-result-item');

//   familyButtons.forEach(button => {
//     button.addEventListener('click', function() {

//       const selectedFamily = this.dataset.family;

//       // active state
//       familyButtons.forEach(btn => btn.classList.remove('is-active'));
//       this.classList.add('is-active');

//       // filter color
//       colorItems.forEach(item => {
//         if (item.dataset.family === selectedFamily) {
//           item.style.display = '';
//         } else {
//           item.style.display = 'none';
//         }
//       });

//     });
//   });

// });



/*
==================================================
RELATED PRODUCTS BY VARIANT
==================================================
*/
(function () {

  let activeVariantId = null;

  
  /*
  ==================================================
  GET ITEMS
  ==================================================
  */
  function getItems() {

    return document.querySelectorAll(
      '#related-products-list .product-item[data-related-group]'
    );

  }

  /*
  ==================================================
  REFRESH FLICKITY
  ==================================================
  */
  // function refreshSlider() {

  //   const slider = document.querySelector(
  //     '#related-products-list'
  //   );

  //   if (!slider) return;

  //   const flkty = Flickity.data(slider);

  //   if (!flkty) return;

  //   flkty.reloadCells();
  //   flkty.resize();
  //   flkty.select(0);

  // }

  /*
  ==================================================
  SET VARIANT
  ==================================================
  */
function revealSlider() {
  const el = document.querySelector('#related-products-list');
  if (!el) return;

  el.classList.add('is-ready');
}
function safeReveal() {

  // 1. normal reveal
  revealSlider();

  // 2. failsafe 
  setTimeout(() => {
    revealSlider();
  }, 1200);

}
  function reveal() {
  document.querySelector('#related-products-list')
    ?.style.setProperty('opacity', '1');
}

 function setVariant(variantId) {

  if (!variantId) return;

  if (String(activeVariantId) === String(variantId)) return;

  activeVariantId = variantId;

  const items = getItems();
  if (!items.length) return;

  const manualSelector =
    `#related-products-list .product-item[data-related-group="${variantId}"]`;

  const manualItems = document.querySelectorAll(manualSelector);
  const hasManual = manualItems.length > 0;

  const targetItems = hasManual
    ? manualItems
    : document.querySelectorAll(
        '#related-products-list .product-item[data-related-group="default"]'
      );

  /*
  ==================================================
  PHASE 1: HIDE (DEFERRED)
  ==================================================
  */
  requestAnimationFrame(() => {

    for (let i = 0; i < items.length; i++) {
      items[i].style.display = 'none';
    }

    /*
    ==================================================
    PHASE 2: SHOW (NEXT FRAME)
    ==================================================
    */
    requestAnimationFrame(() => {

      for (let i = 0; i < targetItems.length; i++) {
        targetItems[i].style.display = '';
      }

      /*
      ==================================================
      PHASE 3: REVEAL AFTER LAYOUT SETTLE
      ==================================================
      */
      requestAnimationFrame(() => {
        safeReveal();
      });

    });

  });

}
/*
==================================================
INIT
==================================================
*/

function waitForReady(cb) {

  const check = () => {

    const el = document.querySelector('#related-products-list');
    const items = el?.querySelectorAll('.product-item');

    const ready =
      el &&
      items &&
      items.length > 0

    if (ready) {
      cb();
    } else {
      requestAnimationFrame(check);
    }
  };

  check();
}
function init() {

  window.addEventListener('load', () => {

    waitForReady(() => {

      const input = document.querySelector(
        'form[action*="/cart/add"] [name="id"]'
      );

      const variantId = input?.value;

      if (!variantId) return;

      setVariant(variantId);

    });

  });

}

  /*
  ==================================================
  VARIANT CHANGE
  ==================================================
  */
document.addEventListener('variant:change', function (e) {

  const variantId = e.detail?.variant?.id;

  if (!variantId) return;

  waitForReady(() => {
    setVariant(variantId);
  });

});

  /*
  ==================================================
  START
  ==================================================
  */
  init();

})();

window.addEventListener('load', () => {

  /*
  ==========================================
  SHOPIFY FORM
  ==========================================
  */

  setTimeout(() => {

    document.querySelectorAll('shopify-forms-embed').forEach((el) => {

      const root = el.shadowRoot;

      if (!root) return;

      const style = document.createElement('style');

      style.textContent = `
        * {
          font-family: "myriad-pro", sans-serif !important;
        }

        input,
        button,
        label,
        textarea {
          font-size: 1.25rem !important;
          color: #000000 !important;
        }

        button[type="submit"] {
          width: 50% !important;
          border-radius: 30px !important;
          margin: 20px auto !important;
          color: #ffffff !important;
        }
      `;

      root.appendChild(style);

    });

  }, 500);



  /*
  ==========================================
  HEADER SELECTOR ROOT
  ==========================================
  */
  setTimeout(() => {
    document.querySelectorAll('.header__action-list selector-root').forEach((el) => {

      const root = el.shadowRoot;

      if (!root) return;

      const style = document.createElement('style');

      style.textContent = `
        @media (min-width: 999px) and (max-width: 1279px){
          button#P0-0 {
            width: 50px !important;
          }  
          .sel-itemsContainer {
            width: auto !important;
          }
        }
      `;

      root.appendChild(style);

    });
  }, 500);
  /*
  ==========================================
  SELECTOR ROOT
  ==========================================
  */
  setTimeout(() => {
    document.querySelectorAll('selector-root').forEach((el) => {

      const root = el.shadowRoot;

      if (!root) return;

      const style = document.createElement('style');

      style.textContent = `
        span{
          font-family: "myriad-pro", sans-serif !important;
          font-size: 1rem !important;
          color: #000000 !important;
        }
      `;

      root.appendChild(style);

    });
  }, 500);

});
